const release = '0.11.4'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js